







import { Component, Vue } from 'vue-property-decorator'
import TeamBoard from './TeamBoard.vue'
import Timer from './Timer.vue'

@Component({ name: 'ScoreBoard', components: { TeamBoard, Timer } })
export default class MyComponent extends Vue {}
